import axios from 'axios';
import { setupReLoginInterceptor } from './interceptors/reLogin';
import { setupHandleErrorInterceptor } from './interceptors/handleError';
const instance = axios.create();
setupReLoginInterceptor(instance);
setupHandleErrorInterceptor(instance);
export default instance;
